<template>
    <table class="table-activate">
      <thead class="sticky top-0 bg-white">
        <tr>
          <th v-for="column in internalTableColumns" :key="column.key" :class="['py-[13px] pl-[24px] h-[58px] align-center', column.thStylingClasses ]">
            <div :class="[column.sortable ? 'flex justify-between items-center' : '']">
              <span>{{ column.label }}</span>
              <div v-if="column.sortable || false">
                <button
                  class="border-0 bg-transparent p-0 cursor-pointer"
                  @click="handleColumnSort(column.key)"
                >
                  <div :class="{
                    'h-[7px]': true,
                    'text-jet': isColumnSorted(column, sortOrder.desc), 'text-jet/40': !isColumnSorted(column, sortOrder.desc)
                  }">
                    <font-awesome-icon icon="fa-solid fa-caret-up" />
                  </div>
                  <div :class="{
                    'h-[20px]': true,
                    'text-jet': isColumnSorted(column, sortOrder.asc),
                    'text-jet/40': !isColumnSorted(column, sortOrder.asc)
                  }">
                    <font-awesome-icon icon="fa-solid fa-caret-down" />
                  </div>
                </button>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isTableEmpty || searchResult.isEmpty">
          <td align="center" :colspan="internalTableColumns.length" class="font-bold py-20">
            <div class="w-[335px] text-left m-auto">
              <template v-if="searchResult.isEmpty">
                <div class="font-bold">{{ $t('licenseOrdering.noRecordsFound', { query: searchResult.keyword }) }}</div>
                <ul class="list-disc font-normal text-xs pt-2 pl-[22px]">
                  <li class="pb-2">{{ $t('licenseOrdering.noRecordsFoundNote1') }}</li>
                  <li>{{ $t('licenseOrdering.noRecordsFoundNote2') }}</li>
                </ul>
              </template>
              <template v-else-if="isTableEmpty">
                <div>{{ noEntriesText }}</div>
              </template>
            </div>
          </td>
        </tr>
        <tr
          v-else
          v-for="(row) in tableData"
          :key="row.id"
          :id="row.id"
          :style="{'white-space': 'nowrap'}"
          :class="['text-sm', row.trStylingClasses]">
          <td v-for="column in internalTableColumns" :key="column.key" :class="['py-[14px] pl-[24px] h-[64px] text-left', column.tdStylingClasses]" :data-component-element-id="column.key">
            <!-- Warning for v-bind still happens here so a manually adding COMPILER_V_BIND_OBJECT_ORDER in compatConfig was done -->
            <component
              class="text-left"
              v-bind="columnComponentProps[row.id][column.key]"
              :is="getComponent(column, row)"
              @click="(data) => handleColumnEvent(column.type, 'click', data)"
              @blur="(data) => handleColumnEvent(column.type, 'blur', data)"
              @focus="(data) => handleColumnEvent(column.type, 'focus', data)"
              @change="(data) => handleColumnEvent(column.type, 'change', data)"
              @enter="(data) => handleColumnEvent(column.type, 'enter', data)"
              />
          </td>
        </tr>
      </tbody>
    </table>
</template>

<script src="./table.js"></script>
<style lang="scss" src="./table.scss"></style>
